<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>

export default {
  name: "odoo-sale-order-state-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        {
          value: null,
          text: this.placeholder ?
              this.placeholder : this.$t('Please select {something}', {something: this.$t('sale_notes.odoo_sale_orders.state')})
        },
        {
          value: 'draft',
          text: this.lodash.startCase(this.$t('sale_notes.odoo_sale_orders.states.draft')),
        },
        {
          value: 'sale',
          text: this.lodash.startCase(this.$t('sale_notes.odoo_sale_orders.states.sale')),
        },
        {
          value: 'done',
          text: this.lodash.startCase(this.$t('sale_notes.odoo_sale_orders.states.done')),
        },
        {
          value: 'cancel',
          text: this.lodash.startCase(this.$t('sale_notes.odoo_sale_orders.states.cancel')),
        },
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val) {
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
